import React from "react";
import { Route } from "react-router-dom";
import PrivacyPolicy from "../components/index";

const PrivacyPolicyRoutes = () => {
  return (
    <>
      <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
    </>
  );
};

export default PrivacyPolicyRoutes;
